<ng-container *ngIf="(orange$ | async) as orange">
    <div id="userDataForm" class="container content" [formGroup]="userDataFormGroup">
        <h5 class="title-step text-center" >
            <img src="./assets/img/users.svg" class="img-fluid ico-title" width="20"> Datos personales
        </h5>
        <div class="card">
            <ul class="list-group list-group-flush">
                <li class="list-group-item cuerpo-pack">
                    <div class="row">
                        <div class="col-lg-3 mt-3" [ngClass]="{'custom-error': checkErrorFieldForm('document_type', ['required'])}">
                            <digo-select
                                id="document"
                                label="Tipo documento"
                                [formGroup]="userDataFormGroup"
                                controlName="document_type"
                                [options]="document_types"
                                optionValue="document_type_id"
                                optionLabel="name"
                                [isRequired]="true"
                                (OnChange)="changeTypeDocument($event.target.value);setMaxLengthByDoc($event.target.value);"
                                [returnFullObject]="'true'"
                                [highlightError]="true"
                                />

                        </div>

                        <div class="col-lg-3 mt-3" [ngClass]="{'custom-error': checkErrorFieldForm('document_number', ['required', 'doc'])}">
                            <digo-input
                                id="document_number"
                                label="Nº de documento"
                                [formGroup]="userDataFormGroup"
                                controlName="document_number"
                                isRequired="true"
                                type="text"
                                (keypress)="alphanumericOnly($event)"
                                [maxlength]="maxLengthByDoc"
                                [highlightError]="true"
                            />
                        </div>

                        <div class="col-lg-3 mt-3" [ngClass]="{'custom-error': checkErrorFieldForm('nacionality', ['required'])}">
                            <digo-select
                                id="country"
                                label="Nacionalidad"
                                [formGroup]="userDataFormGroup"
                                controlName="nacionality"
                                [options]="countries"
                                isRequired="true"
                                optionValue="country_id"
                                optionLabel="name"
                                [highlightError]="true"
                                />
                        </div>

                        <div class="col-lg-3 mt-3" [ngClass]="{'custom-error': checkErrorFieldForm('birth_date', ['required', 'date_minimum','date_maximum'])}">
                                <digo-datepicker
                                    id="birth_date"
                                    label="Fecha de nacimiento"
                                    [formGroup]="userDataFormGroup"
                                    controlName="birth_date"
                                    [isRequired]="true"
                                    [highlightError]="true"
                                />
                        </div>

                        <div class="col-lg-3 mt-3" [ngClass]="{'custom-error': checkErrorFieldForm('name', ['required','blankSpace'])}">
                            <digo-input
                                id="name"
                                label="Nombre"
                                [formGroup]="userDataFormGroup"
                                controlName="name"
                                [isRequired]="true"
                                type="text"
                                [highlightError]="true"
                            />
                        </div>

                        <div class="col-lg-3 mt-3" [ngClass]="{'custom-error': checkErrorFieldForm('first_surname', ['required','blankSpace'])}">
                            <digo-input
                                id="first_surname"
                                label="Primer apellido"
                                [formGroup]="userDataFormGroup"
                                controlName="first_surname"
                                isRequired="true"
                                type="text"
                                [highlightError]="true" />
                        </div>

                        <div class="col-lg-3 mt-3" [ngClass]="{'custom-error': checkErrorFieldForm('second_surname', ['required'])}">
                            <digo-input
                                id="second_surname"
                                label="Segundo apellido"
                                [formGroup]="userDataFormGroup"
                                controlName="second_surname"
                                type="text"
                            />
                        </div>

                        <div class="col-lg-3 mt-3" [ngClass]="{'custom-error': checkErrorFieldForm('sex', ['required'])}">
                            <digo-select
                                id="sex"
                                label="Sexo"
                                [formGroup]="userDataFormGroup"
                                controlName="sex"
                                [options]="orange?.master?.genders"
                                optionValue="gender_id"
                                optionLabel="name"
                                isRequired="true"
                                [highlightError]="true"
                                />
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <h5 class="title-step mt-5 text-center" >
            <img src="./assets/img/users.svg" class="img-fluid ico-title" width="20"> Datos de contacto
            <ng-container>
                <img src="./assets/img/info.svg" class="img-fluid icon-list me-1 cursor-pointer"
                [ngbTooltip]= mailInfo
                [placement]="'right'"
                width="16" tooltipClass="my-custom-class">
            </ng-container>
        </h5>
        <div class="card">
            <ul class="list-group list-group-flush">
                <li class="list-group-item cuerpo-pack">
                    <div class="row">
                        <div class="col-lg-3 mt-3" [ngClass]="{'custom-error': checkErrorFieldForm('postal_code', ['required'])}">
                            <digo-input
                                id="codigoPostal"
                                [label]="'Código Postal'"
                                [isRequired]="true"
                                [formGroup]="userDataFormGroup"
                                controlName="postal_code"
                                type="number"
                                min="0"
                                max="99999"
                                pattern="\d+"
                                (OnInput)="onChangeZip($event.target.value)"
                                (OnKeyDown)="onlyPositiveDigits($event)"
                                [highlightError]="true"
                                />
                        </div>

                        <div class="col-lg-3 mt-3" [ngClass]="{'custom-error': checkErrorFieldForm('province', ['required'])}">
                            <!-- <mat-form-field class="pt-1">
                                <mat-label>Provincia</mat-label>
                                <select matNativeControl formControlName="province" required [ngModel]="orange?.user_data_form_values.province">
                                    <option *ngFor="let province of orange?.master?.provinces" [ngValue]="province">
                                        {{province.name}}
                                    </option>
                                </select>
                                <mat-error *ngIf="checkErrorFieldForm('province', ['required'])">
                                    Campo obligatorio.
                                </mat-error>
                            </mat-form-field> -->
                            <digo-select
                                id="province"
                                label="Provincia"
                                [formGroup]="userDataFormGroup"
                                controlName="province"
                                [options]="orange?.master?.provinces"
                                optionValue="province_id"
                                optionLabel="name"
                                [isDisabled]="true"
                            />
                        </div>

                        <div class="col-lg-3 mt-3" [ngClass]="{'custom-error': checkErrorFieldForm('email', ['required','invalid','pattern'])}">

                            <digo-input
                                id="email_orange"
                                label="Correo electrónico"
                                [formGroup]="userDataFormGroup"
                                controlName="email"
                                isRequired="true"
                                type="text"
                                [highlightError]="true"
                                [activeBlockPaste]="true"
                                autocomplete="off"
                            />
                        </div>

                        <div class="col-lg-3 mt-3" [ngClass]="{'custom-error': checkErrorFieldForm('email_confirm', ['required','invalid','pattern'])}">

                            <digo-input
                                id="email_confirm"
                                label="Confirmar Correo electrónico"
                                [formGroup]="userDataFormGroup"
                                controlName="email_confirm"
                                isRequired="true"
                                type="text"
                                [activeBlockPaste]="true"
                                [highlightError]="true"
                                autocomplete="off"
                            />
                        </div>
                       
                    </div>
                </li>
            </ul>
        </div>

        <h5 class="title-step mt-5 text-center" >
            <img src="./assets/img/check-user.svg" class="img-fluid ico-title" width="20"> Protección de datos
        </h5>
        <div class="card">
            <ul class="list-group list-group-flush">
                <li class="list-group-item cuerpo-pack">
                    <div class="container" [formGroup]="agreementsFormGroup">
                        <div class="area-check">
                            <div class="checkbox icheck-primary">
                                <input type="checkbox" id="check1" class="accept-check" formControlName="check1"/>
                                <label for="check1">
                                    Deseo recibir comunicaciones comerciales de ORANGE ajustadas a mi perfil comercial según los datos derivados del Servicio como tráfico, navegación y localización.
                                </label>
                            </div>

                            <div class="checkbox icheck-primary">
                                <input type="checkbox" id="check2" class="accept-check" formControlName="check2"/>
                                <label for="check2">
                                    Deseo recibir publicidad de compañías con las que ORANGE colabora que ofrecen productos y servicios de telecomunicaciones, financieros, seguros, tecnología, energía, audiovisual, seguridad, educación, ocio, automoción, publicidad y gran consumo.
                                </label>
                            </div>

                            <div class="checkbox icheck-primary">
                                <input type="checkbox" id="check3" class="accept-check" formControlName="check3"/>
                                <label for="check3">
                                    Consiento la cesión de mis datos a sociedades participadas y empresas del Grupo Orange, incluido mi perfil comercial, para la remisión por su parte de acciones comerciales personalizadas (el listado completo de empresas y su actividad está disponible en www.orange.es.
                                </label>
                            </div>

                            <div class="checkbox icheck-primary">
                                <input type="checkbox" id="check4" class="accept-check" formControlName="check4"/>
                                <label for="check4">
                                    Consiento la elaboración de un perfil comercial, basado en información proveniente de terceros, que permita a ORANGE la adopción de decisiones automatizadas.
                                </label>
                            </div>

                            <div class="checkbox icheck-primary">
                                <input type="checkbox" id="check5" class="accept-check" formControlName="check5"/>
                                <label for="check5">
                                    Consiento la comunicación de mis datos, incluido mi perfil comercial, a compañías con las que Orange colabora en los siguiente sectores: telecomunicaciones, financieros, seguros, tecnología, energía, audiovisual, seguridad, educación, ocio, automoción, publicidad y gran consumo, para que puedan facilitarme información comercial adaptada a mis gustos y preferencias.
                                </label>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    <!-- Notificación -->
    <div class="alert" *ngIf="showErrorOrder" [ngClass]="{'alert-danger': showErrorOrder}" role="alert">
        <p *ngIf="showErrorOrder">
            {{ showErrorOrderMsg || 'No se ha podido realizar la tramitación. Por favor, inténtelo de nuevo más tarde.' }}
        </p>
    </div>
        <!-- Continuar proceso -->
        <div class=" d-flex justify-content-center">
            <br>
            <button class="btn btn-black d-block w-100 mb-5 mt-4 pt-3 fw-bold" style="padding-bottom: 20px !important; width: 100% !important;" (click)="next(orange?.orderDraftId)" role="button" [disabled]="isCreateLoading">
                Continuar <img *ngIf="!isCreateLoading" src="./assets/img/arrow-right-white.svg" class="img-fluid ico-title" width="15">
                <span *ngIf="isCreateLoading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            </button>
            <br><br>
        </div>
    </div>
</ng-container>
